<section class="dashboard">
	@if (operatorStateSrv.dashboard(); as dashboard) {
		<div class="date-label"></div>
		<section class="shift-summary" aria-labelledby="today-shift-title">
			<div class="container">
				<div style="text-align: start; width: 100%">
					<span class="shift-label">{{ formatLongDate(dashboard.today) }}</span>
					<h1 id="today-shift-title">
						{{ dashboard.todayReservationCount }} κρατήσεις ·
						{{ dashboard.todayGuestCount }} επισκέπτες
					</h1>
					<div class="shift-meta">
						@if (dashboard.todayFirstStartsAt) {
							<span>
								Πρώτη κράτηση
								{{ formatTime(dashboard.todayFirstStartsAt) }}
							</span>
						}
						<span>{{ dashboard.todayPendingCount }} σε αναμονή</span>
					</div>
				</div>
				<button class="shift-button" type="button" (click)="openShift()">
					<span>Άνοιγμα Βάρδιας</span>
					<!-- <span aria-hidden="true">→</span> -->
					<img src="/assets/icons/chevron-right.svg" alt="" />
				</button>
			</div>
		</section>

		<!-- @if (operatorStateSrv.realtime() === true) {
			<div class="date-label" style="margin: 1rem 0.5rem">REALTIME</div>
		} -->
		<section class="stats" aria-label="Εβδομαδιαία στατιστικά">
			<article class="stat stat--reservations">
				<div class="stat-heading">
					<span class="stat-icon stat-icon--calendar" aria-hidden="true"></span>
					<h2>Κρατήσεις εβδομάδας</h2>
				</div>
				<strong class="stat-value">{{
					dashboard.stats.reservationCount
				}}</strong>
				<div class="stat-breakdown" aria-label="Κρατήσεις ανά πηγή">
					<div class="stat-breakdown-item">
						<span
							class="detail-icon detail-icon--online"
							aria-hidden="true"
						></span>
						<div>
							<strong>{{ dashboard.stats.onlineCount }}</strong>
							<span>Online</span>
						</div>
					</div>
					<div class="stat-breakdown-item">
						<span
							class="detail-icon detail-icon--phone"
							aria-hidden="true"
						></span>
						<div>
							<strong>{{ dashboard.stats.phoneCount }}</strong>
							<span>Τηλεφωνικές</span>
						</div>
					</div>
					<div class="stat-breakdown-item">
						<span
							class="detail-icon detail-icon--walk-in"
							aria-hidden="true"
						></span>
						<div>
							<strong>{{ dashboard.stats.walkInCount }}</strong>
							<span>Walk-in</span>
						</div>
					</div>
				</div>
			</article>
			<article class="stat">
				<div class="stat-heading">
					<span class="stat-icon stat-icon--guests" aria-hidden="true"></span>
					<h2>Επισκέπτες</h2>
				</div>
				<strong class="stat-value">{{ dashboard.stats.guestCount }}</strong>
				<div class="stat-supporting">
					<span
						class="detail-icon detail-icon--guests"
						aria-hidden="true"
					></span>
					<span>
						{{
							averageGuests(
								dashboard.stats.guestCount,
								dashboard.stats.reservationCount
							)
						}}
						άτομα / κράτηση
					</span>
				</div>
			</article>
			<article class="stat">
				<div class="stat-heading">
					<span class="stat-icon stat-icon--no-show" aria-hidden="true"></span>
					<h2>No-show</h2>
				</div>
				<strong class="stat-value">{{ dashboard.stats.noShowCount }}</strong>
				<div class="stat-supporting">
					<span
						class="detail-icon detail-icon--check"
						aria-hidden="true"
					></span>
					<span>
						{{
							noShowRate(
								dashboard.stats.noShowCount,
								dashboard.stats.reservationCount
							)
						}}% των κρατήσεων
					</span>
				</div>
			</article>
		</section>

		<div class="pending-heading">
			<div>
				<h2>Χρειάζονται επιβεβαίωση</h2>
			</div>
			<span>{{ dashboard.pendingReservations.length }} σε αναμονή</span>
		</div>
		<section class="pending-list" aria-live="polite">
			@if (!dashboard.pendingReservations.length) {
				<div class="empty-state">
					<span>Όλες οι online κρατήσεις έχουν επιβεβαιωθεί.</span>
				</div>
			} @else {
				@for (
					reservation of dashboard.pendingReservations;
					track reservation.id
				) {
					<app-operator-reservation-card
						[reservation]="reservation"
						[timezone]="operatorStateSrv.context()!.timezone"
						[referenceServiceDate]="dashboard.today"
						[expanded]="expandedReservationId() === reservation.id"
						[saving]="operatorStateSrv.saving()"
						(toggled)="toggleReservation(reservation.id)"
						(editRequested)="openEdit(reservation)"
						(transitionRequested)="transition(reservation, $event)"
					/>
				}
			}
		</section>
	} @else if (operatorStateSrv.loading()) {
		<div class="dashboard-state" role="status">Φόρτωση αρχικής οθόνης…</div>
	} @else {
		<div class="dashboard-state">
			<strong>Δεν φορτώθηκε η αρχική οθόνη</strong>
			<button
				class="button button--accent"
				type="button"
				(click)="operatorStateSrv.loadDashboard()"
			>
				<img src="/assets/icons/rotate-right-solid-full.svg" alt="" />
				Δοκιμή ξανά
			</button>
		</div>
	}
</section>

@if (editorMode(); as mode) {
	<app-operator-reservation-editor
		[mode]="mode"
		[reservation]="editing()"
		(closed)="closeEditor()"
	/>
}
